import { useCallback, useEffect, useState } from 'react';
import { getInterventions } from '../services/intervention.api';
export default function useInterventions(filters) {
  const [data, setData] = useState({ items: [], total: 0, page: 1, pageSize: 20 }); const [loading, setLoading] = useState(true); const [error, setError] = useState('');
  const reload = useCallback(async () => { try { setLoading(true); setData(await getInterventions(filters)); setError(''); } catch (e) { setError(e.message); } finally { setLoading(false); } }, [filters]);
  useEffect(() => { reload(); }, [reload]); return { ...data, loading, error, reload };
}
